























import Vue from 'vue'
import Component from 'vue-class-component'
import ModalV2 from '@/components/modals/ModalV2.vue'
import TextareaV2 from '@/components/inputsV2/TextareaV2.vue'
import { required } from 'vuelidate/lib/validators'
import InputValidator from '@/components/inputsV2/InputValidator.vue'
const { VueEditor } = require('vue2-editor')
@Component({
  components: {
    InputValidator,
    TextareaV2,
    VueEditor,
    ModalV2
  },
  props: {
    templateDescription: {}
  }
})
export default class UpdateDescriptionModal extends Vue {
  customToolbar = [
    ['bold', 'italic', 'underline'],
    [{ list: 'ordered' }, { list: 'bullet' }]
  ]
  validations (): any {
    return {
      templateDescription: {
        description: {
          required
        }
      }
    }
  }
  emitUpdate () {
    this.$v.$touch()
    if (this.$v.$anyError) {
      return
    }
    this.$emit('update', this.$props.templateDescription)
  }
}
